export const APP_SUPPORT_EMAIL = "AppSupport@citymd.net";
